// Maja — Ballingo's 22-year-old Balkan assistant character.
// Ported from design_handoff_ballingo/mascot.jsx.

const SKIN = '#F4C9A0';
const SKIN_DK = '#C99670';
const HAIR = '#1A1A1F';
const INK = '#1A1A2E';

function MajaEyes({ mood = 'happy', cx1 = 65, cx2 = 95, cy = 50 }) {
  if (mood === 'cheer') {
    return (
      <g stroke={INK} strokeWidth="2.4" strokeLinecap="round" fill="none">
        <path d={`M${cx1 - 5} ${cy} q5 -5 10 0`} />
        <path d={`M${cx2 - 5} ${cy} q5 -5 10 0`} />
      </g>
    );
  }
  if (mood === 'wink') {
    return (
      <g fill={INK}>
        <ellipse cx={cx1} cy={cy} rx="3" ry="4" />
        <circle cx={cx1 + 1} cy={cy - 1} r="1.1" fill="#fff" />
        <path d={`M${cx2 - 5} ${cy} q5 -4 10 0`} stroke={INK} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      </g>
    );
  }
  if (mood === 'think') {
    return (
      <g fill={INK}>
        <ellipse cx={cx1} cy={cy} rx="3" ry="4" />
        <ellipse cx={cx2} cy={cy} rx="3" ry="4" />
        <circle cx={cx1 + 1} cy={cy - 1.5} r="1" fill="#fff" />
        <circle cx={cx2 + 1} cy={cy - 1.5} r="1" fill="#fff" />
      </g>
    );
  }
  return (
    <g fill={INK}>
      <ellipse cx={cx1} cy={cy} rx="3.2" ry="4.2" />
      <ellipse cx={cx2} cy={cy} rx="3.2" ry="4.2" />
      <circle cx={cx1 + 1.2} cy={cy - 1.5} r="1.3" fill="#fff" />
      <circle cx={cx2 + 1.2} cy={cy - 1.5} r="1.3" fill="#fff" />
    </g>
  );
}

function MajaMouth({ mood = 'happy', cx = 80, cy = 62 }) {
  if (mood === 'think') {
    return <path d={`M${cx - 4} ${cy} h8`} stroke={INK} strokeWidth="2" strokeLinecap="round" />;
  }
  if (mood === 'cheer') {
    return <path d={`M${cx - 8} ${cy - 2} q8 12 16 0 z`} fill="#E63946" stroke={INK} strokeWidth="2" strokeLinejoin="round" />;
  }
  return <path d={`M${cx - 7} ${cy - 1} q7 7 14 0`} fill="#E63946" stroke={INK} strokeWidth="2" strokeLinecap="round" />;
}

export function Maja({ size = 200, mood = 'happy', tshirt = 'ŽIVOT JE LIJEP', tshirtColor = '#fff', style = {} }) {
  const w = size;
  const h = size * 1.4;
  return (
    <svg width={w} height={h} viewBox="0 0 160 220" style={{ display: 'block', ...style }}>
      <ellipse cx="80" cy="214" rx="46" ry="4" fill="rgba(0,0,0,0.15)" />

      <rect x="62" y="166" width="14" height="34" rx="3" fill={SKIN} stroke={INK} strokeWidth="2" />
      <rect x="84" y="166" width="14" height="34" rx="3" fill={SKIN} stroke={INK} strokeWidth="2" />
      <ellipse cx="69" cy="180" rx="6" ry="2" fill={SKIN_DK} opacity="0.4" />
      <ellipse cx="91" cy="180" rx="6" ry="2" fill={SKIN_DK} opacity="0.4" />

      <ellipse cx="69" cy="204" rx="13" ry="6" fill="#fff" stroke={INK} strokeWidth="2" />
      <ellipse cx="91" cy="204" rx="13" ry="6" fill="#fff" stroke={INK} strokeWidth="2" />
      <rect x="56" y="202" width="26" height="4" fill="#fff" stroke={INK} strokeWidth="2" />
      <rect x="78" y="202" width="26" height="4" fill="#fff" stroke={INK} strokeWidth="2" />

      <path d="M44 128 Q44 122 50 122 H110 Q116 122 116 128 L114 168 H86 L80 142 L74 168 H46 Z"
            fill="#3A6FBF" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M80 142 V165 M52 130 H108" stroke="#FFC857" strokeWidth="1" strokeDasharray="2 2" fill="none" />
      <circle cx="62" cy="134" r="1.2" fill="#FFC857" />

      <path d="M34 86 q-4 28 0 50 q4 6 12 4 q4 -4 4 -10 L48 96 Z" fill={SKIN} stroke={INK} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M126 86 q4 28 0 50 q-4 6 -12 4 q-4 -4 -4 -10 L112 96 Z" fill={SKIN} stroke={INK} strokeWidth="2.2" strokeLinejoin="round" />

      <path d="M42 86 Q56 76 66 76 L70 84 H90 L94 76 Q104 76 118 86 L116 132 H44 Z"
            fill={tshirtColor} stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M70 84 H90 Q86 90 80 90 Q74 90 70 84 Z" fill={SKIN_DK} opacity="0.25" />

      <text x="80" y="112" textAnchor="middle"
            fontSize={tshirt.length > 12 ? 8 : 10} fontWeight="900"
            fill={INK} fontFamily="system-ui, -apple-system" letterSpacing="0.5">
        {tshirt}
      </text>
      <line x1="56" y1="118" x2="104" y2="118" stroke={INK} strokeWidth="0.8" opacity="0.7" />

      <rect x="72" y="70" width="16" height="10" fill={SKIN} stroke={INK} strokeWidth="2" />
      <line x1="73" y1="77" x2="87" y2="77" stroke={SKIN_DK} strokeWidth="1" opacity="0.4" />

      <path d="M48 38 Q44 8 80 6 Q116 8 112 38 L116 78 Q104 70 100 60 L100 32 L60 32 L60 60 Q56 70 44 78 Z" fill={HAIR} />

      <ellipse cx="80" cy="46" rx="28" ry="30" fill={SKIN} stroke={INK} strokeWidth="2.5" />

      <path d="M53 36 Q56 18 80 14 Q104 16 108 36 Q102 28 92 30 L86 38 L80 30 L72 38 L66 30 Q58 30 53 36 Z" fill={HAIR} />
      <path d="M52 38 Q50 60 56 76 L60 72 Q58 56 56 38 Z" fill={HAIR} />
      <path d="M108 38 Q110 60 104 76 L100 72 Q102 56 104 38 Z" fill={HAIR} />

      <circle cx="52" cy="52" r="2.4" fill="none" stroke="#FFC857" strokeWidth="1.5" />
      <circle cx="108" cy="52" r="2.4" fill="none" stroke="#FFC857" strokeWidth="1.5" />

      <path d="M58 38 q4 -2 8 0" stroke={INK} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      <path d="M94 38 q4 -2 8 0" stroke={INK} strokeWidth="2.2" fill="none" strokeLinecap="round" />

      <MajaEyes mood={mood} cx1={65} cx2={95} cy={48} />
      <MajaMouth mood={mood} cx={80} cy={62} />

      <ellipse cx="60" cy="58" rx="5" ry="3" fill="#FF8FB2" opacity="0.45" />
      <ellipse cx="100" cy="58" rx="5" ry="3" fill="#FF8FB2" opacity="0.45" />
    </svg>
  );
}

export function MajaHead({ size = 60, mood = 'happy', style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" style={{ display: 'block', ...style }}>
      <path d="M16 50 Q14 16 50 14 Q86 16 84 50 L86 78 Q70 70 68 62 L68 36 L32 36 L32 62 Q30 70 14 78 Z" fill={HAIR} />
      <ellipse cx="50" cy="50" rx="28" ry="30" fill={SKIN} stroke={INK} strokeWidth="2.5" />
      <path d="M22 40 Q24 22 50 18 Q76 20 78 40 Q72 32 62 34 L56 42 L50 34 L42 42 L36 34 Q28 32 22 40 Z" fill={HAIR} />
      <path d="M22 42 Q20 64 26 80 L30 76 Q28 60 26 42 Z" fill={HAIR} />
      <path d="M78 42 Q80 64 74 80 L70 76 Q72 60 74 42 Z" fill={HAIR} />
      <circle cx="22" cy="56" r="2.2" fill="none" stroke="#FFC857" strokeWidth="1.4" />
      <circle cx="78" cy="56" r="2.2" fill="none" stroke="#FFC857" strokeWidth="1.4" />
      <path d="M28 42 q4 -2 8 0" stroke={INK} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      <path d="M64 42 q4 -2 8 0" stroke={INK} strokeWidth="2.2" fill="none" strokeLinecap="round" />
      <MajaEyes mood={mood} cx1={35} cx2={65} cy={52} />
      <MajaMouth mood={mood} cx={50} cy={66} />
      <ellipse cx="30" cy="62" rx="5" ry="3" fill="#FF8FB2" opacity="0.45" />
      <ellipse cx="70" cy="62" rx="5" ry="3" fill="#FF8FB2" opacity="0.45" />
    </svg>
  );
}

export function MajaTip({ children, theme, mood = 'happy', label = 'MAJA KAŽE' }) {
  const t = theme;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
      <MajaHead size={48} mood={mood} />
      <div style={{
        position: 'relative', flex: 1,
        background: t.bgAlt,
        border: `2px solid ${t.hairline}`,
        borderRadius: 14, padding: '10px 12px',
        boxShadow: `0 3px 0 ${t.hairline}`,
      }}>
        <div style={{
          fontSize: 10, fontWeight: 900, color: t.primary,
          letterSpacing: '0.12em', marginBottom: 2,
        }}>{label}</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: t.ink, lineHeight: 1.35 }}>
          {children}
        </div>
        <div style={{
          position: 'absolute', left: -10, top: 16,
          width: 0, height: 0,
          borderTop: '7px solid transparent', borderBottom: '7px solid transparent',
          borderRight: `10px solid ${t.hairline}`,
        }} />
      </div>
    </div>
  );
}

export function MajaFloat({ theme, text, mood = 'happy' }) {
  const t = theme;
  return (
    <div style={{
      position: 'absolute', right: 16, bottom: 110, zIndex: 5,
      display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6,
      pointerEvents: 'none',
    }}>
      <div style={{
        background: t.ink, color: t.bg,
        padding: '8px 12px', borderRadius: 14,
        fontSize: 12, fontWeight: 700, maxWidth: 200,
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        position: 'relative',
      }}>
        {text}
        <div style={{
          position: 'absolute', right: 18, bottom: -7,
          width: 0, height: 0,
          borderLeft: '6px solid transparent', borderRight: '6px solid transparent',
          borderTop: `8px solid ${t.ink}`,
        }} />
      </div>
      <MajaHead size={56} mood={mood} />
    </div>
  );
}
